import makeStyles from '@material-ui/core/styles/makeStyles'
import { DadosLoteamentoComercial } from 'models/Viabilidade/DadosLoteamentoComercial'
import NumberFormat from 'react-number-format'
import * as S from './index.style'

const useStyles = makeStyles(() => ({
  label: {
    fontFamily: 'IBMPlexSans-Bold'
  }
}))

const LoteamentoComercial: React.FC<{ dados: DadosLoteamentoComercial }> = ({ dados }) => {
  const classes = useStyles()

  return (
    <S.Wrapper>
      <S.Campos>
        <S.Label data-cy="labelQtdUnidades" className={classes.label}>
          Quantidade de Unidades
        </S.Label>
        <S.Valor color="secondary" data-cy="valorQtdUnidades">
          <NumberFormat
            value={dados?.quantidadeUnidades}
            displayType="text"
            thousandSeparator="."
            decimalSeparator=","
            allowEmptyFormatting={true}
            defaultValue="-"
          />
        </S.Valor>
      </S.Campos>
      <S.CamposAreaLote>
        <S.Label data-cy="labelAreaLote" className={classes.label}>
          Área Lote (m²)
        </S.Label>
        <S.Valor color="secondary" data-cy="valorAreaLote">
          <NumberFormat
            value={dados?.areaLote}
            displayType="text"
            thousandSeparator="."
            decimalSeparator=","
            allowEmptyFormatting={true}
            defaultValue="-"
            fixedDecimalScale={true}
            decimalScale={2}
          />
        </S.Valor>
      </S.CamposAreaLote>
      <S.Campos>
        <S.Label data-cy="labelQtdPermutas" className={classes.label}>
          Quantidade de Permutas
        </S.Label>
        <S.Valor color="secondary" data-cy="valorQtdPermutas">
          <NumberFormat
            value={dados?.quantidadePermutas}
            displayType="text"
            thousandSeparator="."
            decimalSeparator=","
            allowEmptyFormatting={true}
            defaultValue="-"
          />
        </S.Valor>
      </S.Campos>
      <S.Campos>
        <S.Label data-cy="labelPrecoTabela" className={classes.label}>
          Preço Tabela (R$/Unid)
        </S.Label>
        <S.Valor color="secondary" data-cy="valorPrecoTabela">
          <NumberFormat value={dados?.precoTabela} displayType="text" thousandSeparator="." decimalSeparator="," allowEmptyFormatting={true} defaultValue="-" />
        </S.Valor>
      </S.Campos>
    </S.Wrapper>
  )
}

export default LoteamentoComercial
